import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 16a8 8 0 1 1 8-8 8.01 8.01 0 0 1-8 8M6.27 4.489a.8.8 0 0 0-.385.108.73.73 0 0 0-.384.625v5.528a.755.755 0 0 0 .751.751.75.75 0 0 0 .39-.11l4.5-2.749a.75.75 0 0 0 0-1.282L6.64 4.61a.62.62 0 0 0-.37-.121M6.5 10.3V5.7l3.772 2.275z"
    }, null, -1)
  ])))
}
export default { render: render }